// This file is automatically generated by `generated_js` task. Any changes will be lost
/* tslint:disable */
export const GoCDVersion = {
  "version": "24.3.0",
  "buildNumber": "19261",
  "gitSha": "3d8bed12557f0b310a4bce58f076abbfc2841ae9",
  "fullVersion": "24.3.0-19261",
  "formattedVersion": "24.3.0 (19261-3d8bed12557f0b310a4bce58f076abbfc2841ae9)",
  "copyrightYear": "2024"
}


function stripLeadingPrefix(suffix: string, prefix: string) {
  if (suffix.startsWith(prefix)) {
      suffix = suffix.substring(1);
  }
  return suffix;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/24.3.0/${stripLeadingPrefix(suffix, '/')}`
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/24.3.0/${stripLeadingPrefix(suffix, '#')}`
}
    
